import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../utils/api';

export default function MosquePage() {
  const { identifier } = useParams();
  const [mosque, setMosque] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/public/mosque/${identifier}`)
      .then(r => setMosque(r.data.mosque))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [identifier]);

  if (loading) return <div className="spinner-wrap"><div className="spinner"/></div>;
  if (notFound) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <div className="card" style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: 12 }}>Moschee nicht gefunden</h2>
        <Link to="/join" className="btn btn-primary">Mit PIN beitreten</Link>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: 24 }}>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <div className="card" style={{ textAlign: 'center', marginBottom: 24, padding: 40 }}>
          {mosque.logo_path && <img src={mosque.logo_path} alt="Logo" style={{ width: 80, height: 80, borderRadius: 8, objectFit: 'cover', marginBottom: 16 }} />}
          <h1 style={{ fontFamily: 'Playfair Display', fontSize: 28, color: 'var(--primary)' }}>{mosque.name}</h1>
          <p style={{ color: 'var(--text3)' }}>{mosque.city}</p>
          <Link to="/join" className="btn btn-primary btn-lg" style={{ marginTop: 24 }}>Mit PIN beitreten</Link>
        </div>

        {mosque.upcoming?.length > 0 && (
          <div className="card">
            <h3 style={{ fontSize: 16, marginBottom: 16 }}>Geplante Quiz</h3>
            {mosque.upcoming.map(q => (
              <div key={q.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                <div style={{ fontWeight: 600 }}>{q.title}</div>
                {q.scheduled_at && (
                  <div style={{ fontSize: 13, color: 'var(--text3)' }}>
                    {new Date(q.scheduled_at).toLocaleString('de-CH')}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
